module.exports = __webpack_public_path__ + "img/loginSave.753c45e5.png";